import React from "react";
import { BrowserRouter as Router, Route, Switch, withRouter } from "react-router-dom";
import CustomSnackbar from "../../../components/CustomSnackbar/CustomSnackbar";
import AppContext from '../../../data/AppContext';
import { SnackbarProvider } from "../../../data/SnackbarContext";
import LibraryAwareTheme from "../../../layouts/Main/components/LibraryAwareTheme/LibraryAwareTheme";
import { shouldRenderRoute } from "../../../utils/routingHelpers";
import FoldersPage from "./FoldersPage";


/**
 * @description - The React entry point (and parent component) for the "Folders" page inside of LibraryAware. Acts as a "base"
 * component which subsequent children are rendered underneath. 
 * 
 * When the user navigates to "{userId}/#!/folders", application.js will render this component. This component simply
 * acts as a controller which alweays returns the "FoldersPage" component. We needed this component to stand on its own
 * (instead of merging it's functionality with "FoldersPage") in order to get react-router within our constraints that exist
 * from the existing implementation of Backbone's router.
 *
 * @export
 * @param {object} props
 * @param {int} props.userId - the current authorized user
 * @param {object} props.permissions - contains boolean user role key:value pairs
 * @see: LibraryAwareWeb/Shared/Layouts/_Main.cshtml for props.permissions implementation
 * @todo - replace UserID prop with UserContext reference
 * @returns
 */
export default function FoldersPageContainer(props) {
	const { user, permissions } = props;

	/**
	 * @description - initial user subcontext values
	 */
	const appContext = {
		user: {
			...user,
			...permissions
		},
	};

	/**
	 * @description in order to retain React Routers props we wrap FoldersPage with the withRouter HoC
	 */
	const FoldersPageWithRouter = withRouter(FoldersPage);

	return (
		<AppContext.Provider value={appContext}>
			<SnackbarProvider>
				<LibraryAwareTheme>
					<CustomSnackbar />
					<Router>
						<Switch>
							<Route
								path="/:id"
								render={(props) => {
									if (shouldRenderRoute(props.location.hash)) {
										return <FoldersPageWithRouter />
									}
								}}
							/>
						</Switch>
					</Router>
				</LibraryAwareTheme>
			</SnackbarProvider>
		</AppContext.Provider>
	);
}
